import { Filter } from './Filter';

/**
 * The Query class
 */
export class Query {
  /**
   * The criteria
   */
  public Criteria: Filter;

  /**
   * Create a new Query
   * @param fieldName The field name
   * @param comparison The comparison operator
   * @param value The value(s) (Can be a single value, or array of values)
   */
  constructor(criteria: Filter = new Filter()) {
    this.Criteria = criteria;
  }

  public ToDataQuery() {
    let query: string = this.Criteria.ToDataQuery();
    return query === "" ? "" : `&$filter=${query}`;
  }
}
